import React, { FC, useEffect, useState } from 'react';
import { Droppable } from '@hello-pangea/dnd';
import styled from 'styled-components';

import { Player } from '../../../../../database.schema';
import { useFetchPlayers } from '../../../../api/hooks/use-fetch-players';

const PlayerWrapper = styled.div<{ bgColor?: string | null }>`
  width: 7rem;
  color: white;
  min-height: 1.5rem;
  margin: 0 0 0.25rem;
  text-align: center;
`;
type DropProps = {
  bgColor: string;
  isDraggingOver: boolean;
};
const PlayerDropZone = styled.div<DropProps>`
  background-color: ${(props) => (props.isDraggingOver ? 'grey' : props.bgColor)};
  width: 7rem;
  border: 1px solid black;
  border-radius: 0.25rem;
  height: 2.5rem;
  min-height: 2.5rem;
  padding: 0.5rem;
  text-align: center;
`;

type MatchPlayerProps = {
  dndId: string;
  playerId: number;
  bgColor: string;
  team: string;
  matchIndex: number;
};

export const MatchPlayer: FC<MatchPlayerProps> = ({ dndId, playerId, bgColor, team, matchIndex }): JSX.Element => {
  const [playerName, setPlayerName] = useState('');
  const { data } = useFetchPlayers();
  const players = data as Array<Player>;

  useEffect(() => {
    if (playerId) {
      const player = players.find((player: Player) => player.id === playerId);
      setPlayerName(player?.nickName ?? '');
    }
  }, [playerId, players]);

  return (
    <div>
      <PlayerWrapper bgColor={bgColor} data-testid={`${team}-player-${matchIndex}`}>
        <Droppable droppableId={dndId} isDropDisabled={Boolean(playerName)}>
          {(provided, snapshot): JSX.Element => (
            <PlayerDropZone {...provided.droppableProps} ref={provided.innerRef} isDraggingOver={snapshot.isDraggingOver} bgColor={bgColor}>
              {Boolean(playerName) ? (
                <div>
                  {playerName} <input name={`${team}-player-${matchIndex}`} type="hidden" readOnly value={playerId} />
                </div>
              ) : null}
              {provided.placeholder}
            </PlayerDropZone>
          )}
        </Droppable>
      </PlayerWrapper>
    </div>
  );
};
